export default __webpack_public_path__ + "static/media/arrow-down.2768c40b.svg";